import { useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { usePathHandler } from "src/shared/hooks/usePathHandler";
import { useQueryParams } from "src/shared/hooks/queryparams/useQueryParams";

export const useQueryParamState = (queryParamName: string) => {
  const { pathname } = useLocation();
  const history = useHistory();

  const pathHandler = usePathHandler();

  const value = useQueryParams().get(queryParamName);
  const setValue = useCallback(
    (newValue: string | null) => {
      history.push(
        pathHandler(pathname, (params) => {
          if (newValue === null) {
            params.delete(queryParamName);
          } else {
            params.set(queryParamName, newValue);
          }
          return params;
        }),
      );
    },
    [history, pathname, pathHandler, queryParamName],
  );
  return [value, setValue] as const;
};
